// extracted by mini-css-extract-plugin
module.exports = {"root":"InputLabel_root__3yyRF"};